import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { LocaleString } from '@biw/intl';

import { Alert } from 'components/library';
import { LoaderButton, AvatarPreview } from 'shared';
import AccountHistory from './account-history';
import SelectLanguage from './select-language';
import UserDetails from './user-details';

import './profile.scss';


export default class Profile extends React.Component {

    static propTypes = {
        uploadUserAvatar: PropTypes.func.isRequired,
        isLoginAs: PropTypes.bool.isRequired,
        busyAvatarUpload: PropTypes.bool.isRequired,
        uploadAvatarErrors: PropTypes.array.isRequired,
        dismissError: PropTypes.func.isRequired,
        maxProfileImageFileSize: PropTypes.string.isRequired,
        avatarUrl: PropTypes.string,
        userInitials: PropTypes.string
    }

    state = {
        files: []
    }

    onDrop = files => {
        const reader = new FileReader();

        reader.readAsDataURL( files[ 0 ] );

        reader.addEventListener( 'loadend', () => {
            this.setState( {
                dataUri: reader.result
            } );
        }, false );

        this.setState( {
            files: files
        } );
    }

    uploadImage = event => {
        this.props.uploadUserAvatar( this.state.dataUri );
    }

    clearImage = event => {
        event.preventDefault();

        this.setState( {
            files: []
        } );
    }

    componentWillUnmount() {
        this.props.uploadAvatarErrors.map( ( error ) => this.props.dismissError( error ) );
    }

    render() {
        const file = this.state.files[ 0 ];
        const {
            busyAvatarUpload,
            isLoginAs,
            avatarUrl,
            userInitials,
            uploadAvatarErrors,
            dismissError,
            maxProfileImageFileSize
        } = this.props;

        const canCancel = !!this.state.files.length && !busyAvatarUpload;
        return (
            <div className="profile">
                <section className="user-meta">
                    <UserDetails />
                    <aside className="narrow-form-page avatar-upload">
                        <Dropzone onDrop={ this.onDrop } multiple={ false } name="avatar" className="dropzone">
                            <label className="hidden" aria-hidden htmlFor="avatar"><LocaleString code={ 'profile.avatarUpload' } /></label>
                            <AvatarPreview
                                file={file}
                                avatarUrl={avatarUrl}
                                userInitials={userInitials}
                            />
                        </Dropzone>
                            { uploadAvatarErrors.length !== 0 && uploadAvatarErrors.map( ( error, index ) => (
                                <Alert type={ 'error' } onDismiss={ () => dismissError( error ) } key={ index }>
                                    <p>
                                        { error.responseCode === 413 ?
                                            <LocaleString
                                                code="profile.avatarImageTooLarge"
                                                replaceOptions={ maxProfileImageFileSize }
                                            />
                                        :
                                            error.responseMessage
                                        }
                                    </p>
                                </Alert>
                        ) ) }
                        <LoaderButton
                            fetching={ busyAvatarUpload }
                            handleClick={ this.uploadImage }
                            disabled={ !file || isLoginAs }
                            clientBranding
                        >
                            <LocaleString code="profile.avatarUpload" />
                        </LoaderButton>

                        { canCancel &&
                            <div className="cancel-button-container">
                                <LocaleString TextComponent="a" className="client-link" onClick={this.clearImage} code="common.cancelLabel" />
                            </div>
                        }
                    </aside>
                </section>

                <section className="narrow-form-page change-language-container">
                    <SelectLanguage />
                </section>

                <section>{false && <AccountHistory />}</section>
            </div>
        );
    }
}
